import { render } from "./MessageView.vue?vue&type=template&id=8786ff9c"
import script from "./MessageView.vue?vue&type=script&lang=ts"
export * from "./MessageView.vue?vue&type=script&lang=ts"

import "./MessageView.vue?vue&type=style&index=0&id=8786ff9c&lang=scss"
script.render = render

export default script